import { render } from "./filter-tabs.vue?vue&type=template&id=7154620c"
import script from "./filter-tabs.vue?vue&type=script&lang=js"
export * from "./filter-tabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__